import React, { Component, useContext } from "react";
import { Redirect, Route } from "react-router-dom";
import { AppContext } from "../context";

interface IProps {
  exact?: boolean;
  path: string;
  component: React.ComponentType<any>;
}

const PrivateRoute = ({ component: Component, ...rest }: IProps) => {
  const context: any = useContext(AppContext);
  const isAuth = () => {
    console.log(context);
    return !!context.state.profile;
  };
  return (
    <Route
      {...rest}
      render={(props) =>
        isAuth() === true ? (
          <Component {...props} />
        ) : (
          <Redirect to="/process" />
        )
      }
    />
  );
};

export default PrivateRoute;
